<app-athletic-header></app-athletic-header>
<div class="fluid-container" style="margin-top: 56px">
  <router-outlet></router-outlet>
</div>
<app-toast-display aria-live="polite" aria-atomic="true"></app-toast-display>
